import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './finance-calculator-call-me-back.component.scss';
var FinanceCalculatorCallMeBack = /** @class */ (function (_super) {
    tslib_1.__extends(FinanceCalculatorCallMeBack, _super);
    function FinanceCalculatorCallMeBack(element, analyticsService) {
        var _this = _super.call(this, element) || this;
        _this.count = 1;
        _this.dataChecks = true;
        _this.map = new Map();
        _this.iSstep1Completed = false;
        _this.iSstep2Completed = false;
        _this.iSstep3Completed = false;
        _this.errors = [];
        _this.emptyerrors = [];
        return _this;
    }
    FinanceCalculatorCallMeBack.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.businessType = this.element.querySelector(".js-business-type");
        this.recipientInput = this.element.querySelector("input[name=recipient]");
        this.emailInput = this.element.querySelector("input[name=email]");
        this.subjectInput = this.element.querySelector("input[name=subject]");
        this.selectProvince = this.element.querySelector(".js-vaf__province");
        if (this.selectProvince) {
            this.updateProvince();
        }
        this.entityType = this.element.querySelector(".js-apply-now-entity-type");
        this.businessFields = Array.from(this.element.querySelectorAll(".js-business-apply-now-vaf-cmb"));
        this.southAfricanIdField = this.element.querySelector(".js-hs-apply-now-vissible-id");
        this.currentBank = this.element.querySelector("select[name=current-bank]");
        this.selectProvince = this.element.querySelector(".js-vaf__province");
        this.hiddenEmail = this.element.querySelector("input[name=email]");
        this.hiddenRecipient = this.element.querySelector("input[name=recipient]");
        this.wizardContainer = this.element.querySelector(".form-container-wizard__wizard");
        this.wizardStepsContainer = this.element.querySelector(".form-container-wizard__steps");
        this.bulletContainer = this.element.querySelector(".form-container-wizard__bullets-container");
        this.customHeading = this.element.querySelector(".customHeading");
        this.stepNo = this.element.querySelector(".form-container-wizard__stepno");
        // buttons
        this.closeButton = this.element.querySelector(".js-apply-now-modal-close");
        // this.stepButtons = Array.from(this.element.querySelectorAll(".js_next-step-button"));
        this.backButton = Array.from(this.element.querySelectorAll(".js_prev-step-button"));
        this.step1Button = this.element.querySelector(".js_next-step1-button");
        this.step2Button = this.element.querySelector(".js_next-step2-button");
        this.showStep(1);
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector(".form-container__error");
            this.displayDecline = this.form.querySelector(".form-container__declined");
        }
        this.buttonSubmit = this.element.querySelector(".js_submit-button");
        this.doneSubmit = this.element.querySelector(".js_done-button");
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharingGroupTextArea = this.element.querySelector(".data-sharing-group");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".data-sharing-3rd-party");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".data-sharing-boarders");
        this.dataSharingTeleSaleHideBtn = this.element.querySelector(".data-sharing-telesale-hide-btn");
        this.dataSharingTeleSaleShowBtn = this.element.querySelector(".data-sharing-telesale-show-btn");
        this.dataSharingTeleSaleTextArea = this.element.querySelector(".data-sharing-telesale");
        this.dataSharingSmsShowBtn = this.element.querySelector(".data-sharing-email-show-btn");
        this.dataSharingSmsHideBtn = this.element.querySelector(".data-sharing-email-hide-btn");
        this.dataSharingSmsTextArea = this.element.querySelector(".data-sharing-email");
        this.dataSharingEmailHideBtn = this.element.querySelector(".data-sharing-sms-hide-btn");
        this.dataSharingEmailShowBtn = this.element.querySelector(".data-sharing-sms-show-btn");
        this.dataSharingEmailTextArea =
            this.element.querySelector(".data-sharing-sms");
        this.relPartiesHideBtn = this.element.querySelector(".data-rel-parties-hide-btn");
        //Analytics
        this.form.setAttribute("data-frmcontainer", "business solar loan | personal details");
        this.analyticsService.startDtmApplication("application: borrow for your needs | business lending product", "business lending product");
        this.updatePageName("step 1 personal details form");
    };
    FinanceCalculatorCallMeBack.prototype.bindEvents = function () {
        var _this = this;
        //Step 1 Next Button
        if (this.step1Button) {
            this.step1Button.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step1");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.count += 1;
                    if (!_this.iSstep1Completed && !dataLayer.formisSubmitted)
                        _this.analyticsService.dtmFormComplete("complete", "", true);
                    _this.iSstep1Completed = true;
                    _this.dtmVirtualPage("step 2 business details form");
                    _this.showStep(2);
                    _this.updateForm(_this.entityType.value);
                }
            });
        }
        //Step 2 Next Button
        if (this.step2Button) {
            this.step2Button.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step2");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                _this.dataChecks = true;
                if (valid.length === 0) {
                    if (!_this.dataChecks) {
                        _this.showDisplayView("decline");
                        window.scrollTo(0, 0);
                    }
                    else {
                        _this.count += 1;
                        if (!_this.iSstep2Completed && !dataLayer.formisSubmitted)
                            _this.analyticsService.dtmFormComplete("complete", "", true);
                        _this.iSstep2Completed = true;
                        _this.dtmVirtualPage("step 3 accounts details form");
                        _this.showStep(3);
                    }
                }
            });
        }
        //Step 3 Submit Button Click
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step3");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_this.form);
                }
            });
        }
        //Back button
        if (this.backButton.length) {
            this.backButton.map(function (item) {
                return item.addEventListener("click", function (event) {
                    _this.showPreviousStep(event);
                });
            });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener("click", function (event) {
                return _this.closeForm("done");
            });
        }
        if (this.closeButton) {
            this.closeButton.addEventListener("click", function (event) {
                return _this.closeForm("close");
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        this.showLessBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute("hidden", "true");
            _this.showMoreBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
        });
        this.showMoreBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute("hidden", "true");
            _this.showLessBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.removeAttribute("hidden");
        });
        this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
            _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
            _this.dataSharingGroupShowBtn.removeAttribute("hidden");
        });
        this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute("hidden");
            _this.dataSharingGroupHideBtn.removeAttribute("hidden");
            _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
            _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute("hidden");
            _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
        });
        this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
        });
        this.dataSharingTeleSaleShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.removeAttribute("hidden");
            _this.dataSharingTeleSaleShowBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.removeAttribute("hidden");
        });
        this.dataSharingTeleSaleHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleShowBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.removeAttribute("hidden");
            _this.dataSharingSmsShowBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsShowBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.removeAttribute("hidden");
            _this.dataSharingEmailShowBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailShowBtn.removeAttribute("hidden");
        });
        // This adds slashes to the business registration number
        var businessReg = this.element.querySelector(".js-business-apply-now-vaf-cmb");
        if (businessReg) {
            businessReg.addEventListener("input", function (pEvent) {
                if ((pEvent.inputType !== "deleteContentBackward") && (pEvent.inputType !== "deleteContentForward")) {
                    var reg = pEvent.target.value;
                    pEvent.target.value = _this.validationService.formatBusinessReg(reg);
                }
            });
            businessReg.addEventListener("blur", function (pEvent) {
                var reg = pEvent.target.value;
                pEvent.target.value = _this.validationService.formatExpression(reg);
            });
        }
        if (this.entityType) {
            this.entityType.addEventListener("change", function (pEvent) {
                _this.updateForm(_this.entityType.value);
            });
        }
        if (this.selectProvince) {
            this.selectProvince.addEventListener("click", function (pEvent) {
                _this.updateProvince();
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    FinanceCalculatorCallMeBack.prototype.updateProvince = function () {
        if (this.hiddenEmail) {
            this.hiddenEmail.value = "website@standardbank.co.za";
        }
        if (this.hiddenRecipient) {
            switch (this.selectProvince.value) {
                case "Western Cape":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Nicolaas.Arends@standardbank.co.za,Malikah.Booley@standardbank.co.za";
                    break;
                case "Gauteng":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Denise.Ngwetsheni@standardbank.co.za,Jaco.Roux@standardbank.co.za";
                    break;
                case "Kwazulu Natal":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Vikash.Baijnath@standardbank.co.za,Anneline.Pillay@standardbank.co.za";
                    break;
                case "Limpopo":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Muneer.Shaik@standardbank.co.za";
                    break;
                case "Mpumalanga":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Muneer.Shaik@standardbank.co.za";
                    break;
                case "Eastern Cape":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Roberto.DeSouza@standardbank.co.za";
                    break;
                case "Free State / Northern Cape":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Gabriel.Seloana@standardbank.co.za,Christo.VanWyk@standardbank.co.za";
                    break;
                case "North West":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Christo.VanWyk@standardbank.co.za,Gabriel.Seloana@standardbank.co.za";
                    break;
                default:
                    this.hiddenRecipient.value = "enterprisedirect2@standardbank.co.za";
                    break;
            }
        }
    };
    FinanceCalculatorCallMeBack.prototype.updateForm = function (pType) {
        if (this.southAfricanIdField) {
            var _group = this.southAfricanIdField.closest(".form__group");
            if (pType !== "SOLE") {
                this.southAfricanIdField.classList.remove("form__input--required");
                _group.classList.add("form__group--hidden");
                this.form.querySelector("input[name=business-reg-number]").parentElement.parentElement.classList.remove('hidden');
                this.southAfricanIdField.parentElement.parentElement.classList.add('hidden');
            }
            else {
                this.southAfricanIdField.classList.add("form__input--required");
                _group.classList.remove("form__group--hidden");
                this.form.querySelector("input[name=business-reg-number]").parentElement.parentElement.classList.add('hidden');
                this.southAfricanIdField.parentElement.parentElement.classList.remove('hidden');
            }
        }
        if (this.businessFields) {
            this.businessFields.forEach(function (elem) {
                var _group = elem.closest(".form__group ");
                if (pType !== "SOLE") {
                    elem.classList.add("form__input--required");
                    _group.classList.remove("form__group--hidden");
                }
                else {
                    elem.classList.remove("form__input--required");
                    _group.classList.add("form__group--hidden");
                }
            });
        }
    };
    FinanceCalculatorCallMeBack.prototype.closeForm = function (type) {
        if (type === "close") {
            this.analyticsService.dtmFormAbandon();
        }
        else {
            // this.analyticsService.dtmFormComplete(`complete`, `true`);
            // this.analyticsService.completeDtmApplication();
        }
        this.form.reset();
        window.location.href =
            "/southafrica/business/products-and-services/borrow-for-your-needs/vehicle-and-asset-finance/finance-calculators";
    };
    FinanceCalculatorCallMeBack.prototype.showStep = function (stepId) {
        var showStep = parseFloat(stepId);
        if (this.bulletContainer) {
            var _bullets = Array.from(this.bulletContainer.querySelectorAll(".form-container-wizard__bullets-container--bullet"));
            _bullets.map(function (pItem) {
                var displayStep = parseFloat(pItem.getAttribute("data-step"));
                if (displayStep <= showStep) {
                    pItem.classList.add("form-container-wizard__bullets-container--bullet--active");
                }
                else {
                    pItem.classList.remove("form-container-wizard__bullets-container--bullet--active");
                }
            });
            var _bulletLines = Array.from(this.bulletContainer.querySelectorAll(".form-item-business-solar-loan__form-container-wizard__bullets-container--bullet--link"));
            _bulletLines.map(function (pItem) {
                var displayStep = parseFloat(pItem.getAttribute("data-step"));
                if (showStep > displayStep) {
                    pItem.classList.add("form-item-business-solar-loan__form-container-wizard__bullets-container--bullet--link--active");
                }
                else {
                    pItem.classList.remove("form-item-business-solar-loan__form-container-wizard__bullets-container--bullet--link--active");
                }
            });
        }
        var _steps = Array.from(this.wizardStepsContainer.querySelectorAll(".form-container-wizard__steps--step"));
        var _heading = "";
        _steps.map(function (pStep) {
            var _step = parseFloat(pStep.getAttribute("data-step"));
            if (_step == showStep) {
                _heading = pStep.getAttribute("data-heading");
                pStep.classList.remove("form-container-wizard__steps--hidden");
            }
            else {
                pStep.classList.add("form-container-wizard__steps--hidden");
            }
        });
        var _h3Heading = this.customHeading.querySelector("h3");
        if (_heading != null) {
            _h3Heading.innerHTML = _heading;
        }
        var _stepno = this.stepNo.querySelector("h6");
        if (_stepno != null) {
            _stepno.innerHTML = "STEP " + showStep + " OF 3";
        }
        window.scrollTo(0, 0);
    };
    FinanceCalculatorCallMeBack.prototype.showPreviousStep = function (event) {
        this.showDisplayView("");
        var _target = event.currentTarget;
        var _currentStep = _target.closest("[data-step]");
        var _nextStep = _currentStep.getAttribute("data-step");
        this.showStep(parseFloat(_nextStep));
        window.scrollTo(0, 0);
    };
    FinanceCalculatorCallMeBack.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var _serviceType = form.querySelector("input[name=service-type]");
        var _loanAmount = this.form.querySelector("input[name=loan-amount]");
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _surname = this.form.querySelector("input[name=last-name]");
        var _contactNumber = this.form.querySelector("input[name=phone-number]");
        var _alternativeContactNumber = this.form.querySelector("input[name=alternative-number]");
        var _idNumber = this.form.querySelector("input[name=sa-identity-number]");
        var _businessAccountCurrentlyHeld = this.form.querySelector("select[name=business-account]");
        var _accountNumber = this.form.querySelector("input[name=account-number]");
        var _entityType = this.form.querySelector("select[name=entity-type]");
        var _businessName = this.form.querySelector("input[name=business-name]");
        var _province = this.form.querySelector("select[name=province]");
        var _businessRegNumber = this.form.querySelector("input[name=business-reg-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _existingQuote = this.form.querySelector("select[name=existing-quote]");
        var _businessDescription = this.form.querySelector("input[name=business-do]");
        var _purpose = this.form.querySelector("textarea[name=purpose]");
        var _turnOver = this.form.querySelector("input[name=turnover-tax]");
        var _description = form.querySelector("input[name=description]");
        var _recipient = form.querySelector("input[name=recipient]");
        var _subject = form.querySelector("input[name=subject]");
        var _product = form.querySelector("input[name=product]");
        var _redirect = form.querySelector("input[name=redirect]");
        var _email = form.querySelector("input[name=email]");
        var _popiaConsent = form.querySelector("input[name=popia-consent]");
        var _postData = {
            'serviceType': (_serviceType ? _serviceType.value : ""),
            'howMuchDoYouNeed': (_loanAmount ? _loanAmount.value : ""),
            'firstName': (_firstname ? _firstname.value : ""),
            'surname': (_surname ? _surname.value : ""),
            'contactNo': (_contactNumber ? _contactNumber.value : ""),
            'altContactNo': (_alternativeContactNumber ? _alternativeContactNumber.value : ""),
            'saId': (_idNumber ? _idNumber.value : ""),
            'bankName': (_businessAccountCurrentlyHeld ? _businessAccountCurrentlyHeld.value : ""),
            'bankAccountNo': (_accountNumber ? _accountNumber.value : ""),
            'province': (_province ? _province.value : ""),
            'entityType': (_entityType ? _entityType.value : ""),
            'businessName': (_businessName ? _businessName.value : ""),
            'businessRegistration': (_businessRegNumber ? _businessRegNumber.value : ""),
            'emailAddress': (_emailAddress ? _emailAddress.value : ""),
            'hasExistingVehicleQuote': (_existingQuote ? _existingQuote.value : ""),
            'businessDescription': (_businessDescription ? _businessDescription.value : ""),
            'purpose': (_purpose ? _purpose.value : ""),
            'monthlyTurnOver': (_turnOver ? _turnOver.value : ""),
            'description': (_description ? _description.value : ""),
            'email': (_email ? _email.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'product': (_product ? _product.value : ""),
            'redirect': (_redirect ? _redirect.value : ""),
            'consent': ((_popiaConsent ? (_popiaConsent.checked ? "YES" : "NO") : "NO")),
            dataSharingWithinOurGrpMarketingConsent: this.dataConsentService.getDataConsentValue(form, 'data-sharing-group'),
            dataSharingWithThirdPartiesMarketingConsent: this.dataConsentService.getDataConsentValue(form, 'data-sharing-3rd-party'),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.dataConsentService.getDataConsentValue(form, 'data-sharing-boarders'),
            dataSharingTelesale: this.dataConsentService.getDataConsentValue(form, 'data-sharing-telesale'),
            dataSharingEmail: this.dataConsentService.getDataConsentValue(form, 'data-sharing-email'),
            dataSharingSms: this.dataConsentService.getDataConsentValue(form, 'data-sharing-sms'),
        };
        this.showDisplayView("loader");
        var url = this.baseUrl + "/bcleadUtils/save-business-vaf";
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config)
            .then(function (pResponse) {
            if (pResponse.data === "invalid") {
                _this.analyticsService.dtmFormComplete("complete", pResponse.code, false);
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.dtmVirtualPage("step 4 success form");
                if (!_this.iSstep3Completed && !dataLayer.formisSubmitted)
                    _this.analyticsService.dtmFormComplete("complete", pResponse.code, true);
                _this.iSstep3Completed = true;
                _this.analyticsService.completeDtmApplication();
                _this.dtmVirtualPage('thank you');
                _this.showDisplayView("success");
            }
        })
            .catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FinanceCalculatorCallMeBack.prototype.showDisplayView = function (pDisplay) {
        window.scroll({ top: 50, behavior: "smooth" });
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        this.displayDecline.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            case "decline":
                this.displayDecline.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
        }
    };
    FinanceCalculatorCallMeBack.prototype.dtmVirtualPage = function (pPageNameNew) {
        dataLayer.pageName =
            "business:products and services:borrow for your needs:specialised financing:finance calculator call me back:" +
                pPageNameNew;
        if (typeof _satellite == "object") {
            _satellite.track("globalVirtualPageView");
        }
    };
    FinanceCalculatorCallMeBack.prototype.updatePageName = function (pageName) {
        dataLayer.pageName =
            "business:products and services:borrow for your needs:specialised financing:finance calculator call me back:" +
                pageName;
    };
    return FinanceCalculatorCallMeBack;
}(Base));
export { FinanceCalculatorCallMeBack };



//////////////////
// WEBPACK FOOTER
// ./components/finance-calculator-call-me-back/finance-calculator-call-me-back.component.ts
// module id = 1079
// module chunks = 0